<template>
  <div class="width-full bgg">
    <div class="ls-flex-center">
      <div class="max-width foot">
        <div class="every4">
          <img src="../assets/logo.png" alt="">
        </div>
        <div class="every">
          <div class="word1" @click="$router.push('/about')">{{$t('about')}}</div>
          <div class="moflex">
            <div class="word2" @click="jumpAbout('hover1')">{{ $t('about1') }}</div>
            <div class="word2" @click="jumpAbout('hover2')">{{ $t('about2') }}</div>
            <div class="word2" @click="jumpAbout('hover3')">{{ $t('about3') }}</div>
            <div class="word2" @click="jumpAbout('hover4')">{{ $t('about4') }}</div>
          </div>
          


        </div>
        <div class="every">
          <div class="word1" @click="$router.push('/product')">{{ $t('product') }}</div>
          <div class="moflex">
            <div class="word2" v-for="item in classList" :key="item.id" @click="toPro(item.id)">{{ getlanguage == 'zh' ? item.name : item.name_en }}</div>
            
          </div>

        </div>
        <div class="every">
          <div class="word1" @click="$router.push('/use')">{{ $t('use') }}</div>
          <div class="moflex">
           <div class="word2" v-for="item in class2List" :key="item.id" @click="toUse(item.id)">{{ getlanguage == 'zh' ? item.name : item.name_en }}</div>

          </div>

        </div>
        <div class="every">
          <div class="word1" @click="$router.push('/news')">{{ $t('news') }}</div>
          <div class="moflex">
            <div class="word2" v-for="item in class3List" :key="item.id" @click="toNews(item.id)">{{ getlanguage == 'zh' ? item.name : item.name_en }}</div>

          </div>

        </div>
        <div class="every">
          <div class="word1" @click="$router.push('/contact')">{{ $t('contact') }}</div>
          <div class="moflex">
            <div class="word2" @click="$router.push('/contact')">{{ $t('contact') }}</div>
            <div class="word2" @click="$router.push('/contact')">{{$t('con10')}}</div>
          </div>
          

        </div>
        <div class="every2">
          <img :src="wximg" alt="">
          <div class="word2">{{ $t('foot1') }}</div>

        </div>
        <div class="every3">
          <img src="../assets/logo.png" alt="">
        </div>
      </div>
    </div>
    <div v-if="isSmallScreen" class="word color-white" style="opacity: 0.8;">Copyright Ⓒ2026 {{ $t('foot3') }}   <div class="pointer" style="padding-left: 1rem;" @click="jump2">{{ $t('foot2') }}：{{ $t('foot4') }}</div></div>

    <div v-else class="word color-white" style="opacity: 0.8;">Copyright Ⓒ2026 {{ $t('foot3') }}   <span class="pointer" style="padding-left: 1rem;" @click="jump2">{{ $t('foot2') }}：{{ $t('foot4') }}</span></div>
    
    
  </div>
</template>
   
<script>
import { EventBus } from '../utils/eventBus'
import { index,goods_type,syzn_type,news_type,config_lxwm } from "../api/home";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
      info:'',
      classList:[],
      class2List:[],
      class3List:[],
      wximg:'',
      isSmallScreen:''

		}
	},
  computed: {
    ...mapGetters(["getlanguage"]),
  },
  created(){
    this.getInfo()
    this.getClass()
    this.getClass2()
    this.getClass3()
    this.getDtl()

    
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听
  },
  methods: {
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth <= 1400;
      console.log(window.innerWidth)
      console.log(this.isSmallScreen,999)
    },
    toPro(id){
      this.$router.push({path:'/productclassFy',query:{id:id}})
      setTimeout(()=>{
        window.location.reload()
      },100)
    },
    toUse(id){
      this.$router.push({path:'/use',query:{id:id}})
      setTimeout(()=>{
        window.location.reload()
      },100)
    },
    toNews(id){
      this.$router.push({path:'/news',query:{id:id}})
      setTimeout(()=>{
        window.location.reload()
      },100)
    },
    jumpAbout(ids){
      this.$router.push({ path: '/about'});
      setTimeout(()=>{
        EventBus.$emit('scrollTo', ids); 
      },500)

    },
    getClass(){
      goods_type().then((res) => {
        if (res.code == 1) {
          this.classList = res.data
        }
      })
    },
    getClass2(){
      syzn_type().then((res) => {
        if (res.code == 1) {
          this.class2List = res.data
        }
      })
    },
    getClass3(){
      news_type().then((res) => {
        if (res.code == 1) {
          this.class3List = res.data
        }
      })
    },
    getDtl() {
      config_lxwm().then((res) => {
        if (res.code == 1) {
          this.wximg = res.data.com_gzh
        }
      });
    },
    getInfo() {
      index().then((res) => {
        if (res.code == 1) {
          this.info = res.data
        }
      });
    },
    jump1(){
      window.location.href = 'https://beian.miit.gov.cn/'
    },
    jump2(){
      window.location.href = 'http://www.bjkhrs.com/'
    }
  },
}
</script>

<style scoped lang="scss">
.bgg{
  background: linear-gradient(to right, #5CAAFC, #0A79E5) !important;
  padding: 60px 0 20px 0;
}
.foot{
  display: flex;
  padding-bottom: 80px;
  justify-content: space-between;
  .every{
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .word1{
      font-size: 17px;
      cursor: pointer;
    }
    .moflex{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .word2{
      font-size: 15px;
      color: rgba(255, 255, 255, 0.80) !important;
      padding-top: 15px;
      cursor: pointer;
    }
  }
  .every2{
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 70px;
      height: 70px;
    }
    .word2{
      font-size: 15px;
      color: rgba(255, 255, 255, 0.80) !important;
      padding-top: 15px;
    }
  }
  .every3{
    img{
      width: 190px;
      height: 130px;
    }
  }
}
.word{
  font-size: 12px;
  border-top: 1px solid #D1D1D1;
  text-align: center;
  padding: 10px 0;
  padding-top: 20px;
}

@media (max-width: 1200px) {
  
 .bgg{
    padding: 20px;
  }
  .foot{
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    .every{
      display: flex;
      flex-direction: column;
      align-items: baseline;
      margin-top: 20px;
      .word1{
        font-size: 14px;
        cursor: pointer;
      }
      .moflex{
        display: flex;
        flex-direction: row;
      }
      .word2{
        font-size: 12px;
        padding-top: 10px;
        cursor: pointer;
        padding-right: 20px;
        // text-align: center;
      }
    }
    .every2{
      margin-top: 30px;
      align-items: baseline;
      img{
        width: 50px;
        height: 50px;
      }
      .word2{
        font-size: 12px;
        padding-top: 8px;
      }
    }
    .every3{
     display: none;
    }
    .every4{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 90px;
        height: 60px;
      }
    }
  }
  .word{
    font-size: 12px;
    border-top: 1px solid #D1D1D1;
    text-align: center;
    padding: 10px 0;
    padding-top: 20px;
  }
  
}

@media (min-width: 1201px) {
  .every4{
      display: none;
  }
}
</style>